export default {
    popularProducts: 'Nema popularnih proizvoda',
    favourites: 'Nema omiljenih proizvoda',
    notifications: 'Nema notifikacija',
    ordersByCity: 'Nema narudžbina po gradovima',
    cart: 'Nema proizvoda u korpi',
    collections: 'Nema kolekcija',
    invitations: 'Nema pozivnica',
    inventories: 'Nema inventara',
    reviews: 'Nema komentara i ocjena',
    addresses: 'Nema adresa',
    products: 'Nema proizvoda',
    audit: 'Nema audit logova',
    orders: 'Nema narudžbina',
    stores: 'Nema prodavnica',
    users: 'Nema korisnika',
    role: 'Nema uloga',
    faq: 'Nema pitanja',
    chat: 'Trenutno nemate poruka',
    tokens: 'Nema api tokena',
    noMore: 'Nema više proizvoda. :('
}
